const BASE_LEADGEN_BACKEND_URL = process.env.REACT_APP_BASE_LEADGEN_BACKEND_URL;
const BASE_KAJABI_PRODUCTS_URL = process.env.REACT_APP_KAJABI_BASE_URL;

export const LEADGEN_BACKEND_API_KEY =
  process.env.REACT_APP_BACKEND_API_KEY || 'abc';

export const LEADGEN_BACKEND_SAVE_DATA_ENDPOINT = `${BASE_LEADGEN_BACKEND_URL}/leads/create_or_update`;
export const LEADGEN_BACKEND_CREATE_AI_ENDPOINT = `${BASE_LEADGEN_BACKEND_URL}/open_ai_responses/create`;

export const AI_CONTENT_FROM_TOPIC_ENDPOINT = `${BASE_KAJABI_PRODUCTS_URL}/api/growth/ai_content/from_topic`;
export const AI_CONTENT_FROM_YOUTUBE_ENDPOINT = `${BASE_KAJABI_PRODUCTS_URL}/api/growth/ai_content/from_youtube`;

export const KAJABI_PRODUCTS_API_KEY =
  process.env.REACT_APP_KAJABI_PRODUCTS_API_KEY || 'abc';
